import { useContext, useLayoutEffect } from 'react'

import { Context } from './context'

export const useWideMainLayout = (value = true) => {
  const { setIsWide } = useContext(Context)
  useLayoutEffect(() => {
    setIsWide(value)

    return () => {
      setIsWide(false)
    }
  })
}

export const useIsWideMainLayout = () => {
  const { isWide } = useContext(Context)
  return [isWide]
}

export const useIsZeroPaddingMainLayout = () => {
  const { zeroPadding } = useContext(Context)
  return [zeroPadding]
}

/**
 * Signal that this page has no page header (PageHeaderRenderer is not used).
 * Without a page header, the global header lacks a visual separator between itself
 * and the page content. Calling this hook causes the global header to render a
 * bottom border as a substitute separator.
 *
 * Use this in a layout-effects component (e.g. FullPageMainLayoutEffects) for any
 * full-page route that does not render a page header.
 */
export const useHeaderBorderBottom = (value = true) => {
  const { setHeaderBorderBottom } = useContext(Context)
  useLayoutEffect(() => {
    setHeaderBorderBottom(value)

    return () => {
      setHeaderBorderBottom(false)
    }
  })
}

export const useIsHeaderBorderBottom = () => {
  const { headerBorderBottom } = useContext(Context)
  return [headerBorderBottom]
}
